import moment from "moment";

export const dateFormat = (datetime) => {
      return moment(datetime).format('MM/DD/YYYY hh:mma')
}
